import DeviceAttributes from './DeviceAttributes'

export default DeviceAttributes
